import ExamEntryModal from './ExamEntryModal';

export default ExamEntryModal;
